import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currentStatus',
    standalone: false
})
export class PackageUserCurrentStatusPipe implements PipeTransform {
  transform(currentStatus: string): string {
    return currentStatus === 'Not Started' ? 'Check-in not started' : currentStatus;
  }
}
